import { render, staticRenderFns } from "./ActChange.vue?vue&type=template&id=33d4dc6a&scoped=true"
import script from "./ActChange.vue?vue&type=script&lang=js"
export * from "./ActChange.vue?vue&type=script&lang=js"
import style0 from "./ActChange.vue?vue&type=style&index=0&id=33d4dc6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d4dc6a",
  null
  
)

export default component.exports